var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgVersion7 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M632.9,67.1c43.3,43.3,67.1,100.6,67.1,161.4v242.9c0,60.8-23.8,118.2-67.1,161.4C589.6,676.2,532.3,700,471.5,700H0 V228.5c0-60.8,23.8-118.2,67.1-161.4C110.4,23.8,167.7,0,228.5,0h242.9C532.3,0,589.6,23.8,632.9,67.1z M460.8,600 c76.8,0,139.2-62.5,139.2-139.2V239.2c0-76.8-62.5-139.2-139.2-139.2H239.2C162.5,100,100,162.5,100,239.2V600H460.8z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M497,407.2c0,49.4-40.3,89.7-89.7,89.7H203V292.8c0-49.4,40.3-89.7,89.7-89.7h114.4c49.4,0,89.8,40.3,89.8,89.7V407.2z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVersion7);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/version7.860ecf960507826c8c648cbbe031ae21.svg";